import { render } from "./CreateCommand.vue?vue&type=template&id=e1f6ef06"
import script from "./CreateCommand.vue?vue&type=script&lang=js"
export * from "./CreateCommand.vue?vue&type=script&lang=js"

import exportComponent from "/home/salah/dev/yoda-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__